import { render, staticRenderFns } from "./orderPaySuccess.vue?vue&type=template&id=3f781f41&scoped=true&"
import script from "./orderPaySuccess.vue?vue&type=script&lang=js&"
export * from "./orderPaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f781f41",
  null
  
)

component.options.__file = "src/demo/packageMall/orderPaySuccess.vue"
export default component.exports